import React from "react";

const HeaderBottom = () => {
  return (
    <>
      <section
        id="home"
        className="dtr-section dtr-section-with-bg dtr-hero-section-top-padding bg-blue"
        style={{
          backgroundImage:
            "url(https://i.ibb.co.com/LDqcsgQQ/Screenshot-2025-05-07-T105034-659.png)",
          paddingTop: "85px",
        }}
      ></section>
    </>
  );
};

export default HeaderBottom;